<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="ريزا-ميشال-داود">
<h1><span dir="rtl">ريزا ميشال داود</span></h1>
<p style="text-indent:0px;"><span dir="rtl">ريزا ميشال داود، وُلِدَت في بيروت ١٩٨١، بدأَتِ العمل في سنٍّ مبكرة في مجالات عديدة وهي تكمل دراستها.</span></p><br/>
<p style="text-indent:0px;"><span dir="rtl">درَسَتِ التمثيل ومِن بعدها انتقلَت إلى العمل في كواليس التليفزيون، وتنوَّعَت أعمالها بين برامج الهواة، ومسلسلات وأفلام سينمائيَّة ووثائقيَّة، وقد قرَّرَتِ الانتقال إلى شغفها الأوَّل.. الكتابة.</span></p><br/>
<p style="text-indent:0px;"><span dir="rtl">وهي أمٌّ لولدَين، وتعيش حاليًا في الإمارات العربيَّة المتحدة، ولها كتاب بعنوان "لو يعود".</span></p>
<p style="text-indent:0px;"><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?dcce3e80